module.exports = __webpack_public_path__ + "fonts/inter-v2-latin-regular.woff2?ae3bdea1a1337e878e00c40d5be1e8a4";